var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("div", {
    staticClass: "app-page-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", {
    staticClass: "left"
  }, [_c("search-filter", {
    attrs: {
      data: _vm.filterItemList,
      "filter-items": ["c01TaskState"]
    },
    on: {
      submit: _vm.getFilterCode
    }
  }), _vm.isHasPermission ? _c("el-button", {
    staticClass: "app-inline-btn",
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function click($event) {
        return _vm.create();
      }
    }
  }, [_vm._v("新建 ")]) : _vm._e(), _c("el-input", {
    staticClass: "app-search-input app-inline-btn",
    attrs: {
      size: "mini",
      placeholder: ""
    },
    model: {
      value: _vm.searchKey,
      callback: function callback($$v) {
        _vm.searchKey = $$v;
      },
      expression: "searchKey"
    }
  }, [_c("el-button", {
    attrs: {
      slot: "append",
      icon: "el-icon-search"
    },
    on: {
      click: _vm.searchList
    },
    slot: "append"
  })], 1), _c("el-checkbox", {
    model: {
      value: _vm.byGroup,
      callback: function callback($$v) {
        _vm.byGroup = $$v;
      },
      expression: "byGroup"
    }
  }, [_vm._v("集团")]), _vm.isCpscAdmin || _vm.isAdmin ? _c("el-checkbox", {
    on: {
      change: _vm.adminModelChange
    },
    model: {
      value: _vm.isAdminModel,
      callback: function callback($$v) {
        _vm.isAdminModel = $$v;
      },
      expression: "isAdminModel"
    }
  }, [_vm._v("管理员模式")]) : _vm._e()], 1), _c("div", {
    staticClass: "right"
  }, [_c("el-dropdown", {
    staticClass: "app-inline-btn",
    attrs: {
      size: "small"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success",
      size: "mini"
    }
  }, [_vm._v(" 批量操作"), _c("i", {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", [_vm._v("置作业完成")])], 1)], 1), _c("cpsc-sate-filter", {
    staticClass: "app-inline-btn",
    attrs: {
      data: _vm.filterData
    },
    on: {
      change: _vm.handleTakState
    }
  })], 1)]), _vm.getHeightFlag ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "table",
    staticClass: "task-tree-table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      border: "",
      data: _vm.currentTableData,
      size: "mini",
      stripe: "",
      "max-height": _vm.maxHeight,
      "row-key": "Id",
      "default-sort": {
        prop: "c01TaskCode",
        order: "descending"
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      selectable: _vm.selectable,
      type: "selection",
      fixed: "left",
      width: "39"
    }
  }), _c("el-table-column", {
    attrs: {
      fixed: "left",
      width: "95",
      prop: "c01TaskCode",
      label: "作业编号",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticClass: "el-link el-link--primary is-underline el-link--inner link",
          on: {
            click: function click($event) {
              return _vm.detail(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.c01TaskCode) + " ")])];
      }
    }], null, false, 2511376869)
  }), _c("el-table-column", {
    attrs: {
      label: "被审客户名称",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c01CusName) + " "), scope.row._progress || scope.row._percentage === 100 ? _c("el-progress", {
          attrs: {
            status: scope.row._percentage === 100 ? "success" : "",
            percentage: scope.row._percentage
          }
        }) : _vm._e()];
      }
    }], null, false, 81301599)
  }), _c("el-table-column", {
    attrs: {
      label: "所属部组",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.getStrucName(scope.row.c01StrucCode),
            placement: "top-start"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.c01StrucCode))])])];
      }
    }], null, false, 3724800903)
  }), _c("el-table-column", {
    attrs: {
      label: "报告期间",
      width: "88"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticStyle: {
            "line-height": "normal"
          }
        }, [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c01StartDate, "yyyy-MM-dd")) + " "), _c("div"), _vm._v(" " + _vm._s(_vm._f("date")(scope.row.c01EndDate, "yyyy-MM-dd")) + " ")])];
      }
    }], null, false, 11580625)
  }), _c("el-table-column", {
    attrs: {
      label: "作业架构",
      width: "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.c01StrucType ? _c("div", [_vm._v(_vm._s(scope.row.c01StrucType))]) : _vm._e(), scope.row.upTaskName ? _c("el-popover", {
          attrs: {
            placement: "top-start",
            title: "上级作业",
            width: "200",
            trigger: "hover"
          }
        }, [_c("div", [_c("p", [_vm._v(" " + _vm._s(scope.row.upTaskName) + " ")])]), _c("cpsc-icon", {
          staticStyle: {
            "font-size": "14px"
          },
          attrs: {
            slot: "reference",
            hover: true,
            name: "el-icon-s-order"
          },
          slot: "reference"
        })], 1) : _vm._e()];
      }
    }], null, false, 3278592176)
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("作业架构")]), _c("div", [_vm._v("上级作业")])])]), _c("el-table-column", {
    attrs: {
      label: "业务类型",
      width: "70"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.$options.filters.getBTypeName(scope.row.c01N01Code, "name"),
            placement: "top-start"
          }
        }, [_c("span", [_vm._v(_vm._s(scope.row.c01N01Code))])])];
      }
    }], null, false, 3314562162)
  }), _c("el-table-column", {
    attrs: {
      label: "风险/质控",
      width: "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c01RiskLevel) + "/" + _vm._s(scope.row.c01QCLevel) + " ")];
      }
    }], null, false, 3896633102)
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("风险")]), _c("div", [_vm._v("质控")])])]), _c("el-table-column", {
    attrs: {
      label: "作业名称",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.c01TaskName) + " ")];
      }
    }], null, false, 3670794901)
  }), _c("el-table-column", {
    attrs: {
      label: "报告/预估日期",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.c01ReportNeed ? "是" : "否"))]), !_vm.highlightDate(scope.row) ? _c("div", [_vm._v(" " + _vm._s(_vm._f("date")(scope.row.c01ReportDate, "yyyy-MM-dd")) + " ")]) : _c("el-tooltip", {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: "该作业无法归档，可归档日期应在报告日期后！",
            placement: "top"
          }
        }, [_c("div", {
          staticClass: "is-highlight"
        }, [_vm._v(_vm._s(_vm._f("date")(scope.row.c01ReportDate, "yyyy-MM-dd")) + " "), _c("cpsc-icon", {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            name: "el-icon-question"
          }
        })], 1)])];
      }
    }], null, false, 3701288059)
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("报告日期")]), _c("div", [_vm._v("预估日期")])])]), _c("el-table-column", {
    attrs: {
      label: "创建人/日期",
      width: "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(scope.row.c01CreateStaffName))]), _c("div", [_vm._v(_vm._s(_vm._f("date")(scope.row.c01CreateDate, "yyyy-MM-dd")))])];
      }
    }], null, false, 2400472032)
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("创建人")]), _c("div", [_vm._v("日期")])])]), _c("el-table-column", {
    attrs: {
      label: "干系人",
      width: "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("staff", {
          attrs: {
            id: scope.row.c01Id
          }
        })];
      }
    }], null, false, 3277397005)
  }), _c("el-table-column", {
    attrs: {
      label: "作业状态",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(" " + _vm._s(scope.row.c01FileState) + " ")]), _c("div", [_vm._v(" " + _vm._s(scope.row.c01TaskState) + " ")])];
      }
    }], null, false, 371850143)
  }, [_c("div", {
    staticClass: "table-cell",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("div", [_vm._v("函证领取状态")]), _c("div", [_vm._v("作业状态")])])]), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "90",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.isHasPermissionForItem(scope.row) || _vm.isCreator(scope.row) ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            icon: "el-icon-edit",
            title: "编辑"
          },
          on: {
            click: function click($event) {
              return _vm.create(scope.row);
            }
          }
        }) : _vm._e(), _vm.isCpscAdmin || _vm.isAdmin ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            title: "删除",
            icon: "el-icon-delete"
          },
          on: {
            click: function click($event) {
              return _vm.deleteTask(scope.row);
            }
          }
        }) : _vm._e(), _vm.isHasPermissionForItem(scope.row) || _vm.isCpscAdmin || _vm.isAdmin || _vm.isViewer(scope.row) ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            title: "函证控制表",
            icon: "el-icon-tickets"
          },
          on: {
            click: function click($event) {
              return _vm.toConfirmControls(scope.row);
            }
          }
        }) : _vm._e(), _vm.isCpscAdmin ? _c("el-button", {
          staticClass: "clean-padding",
          attrs: {
            type: "text",
            size: "mini",
            loading: scope.row._loading,
            title: "打包下载函证",
            icon: "el-icon-download"
          },
          on: {
            click: function click($event) {
              return _vm.toCheckDownloadList(scope.row);
            }
          }
        }) : _vm._e()];
      }
    }], null, false, 4250317751)
  })], 1) : _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "custom-loading-box"
  }), _c("template", {
    slot: "footer"
  }, [_c("cpsc-auto-pagination", {
    attrs: {
      "current-page": _vm.currentPage,
      total: _vm.total,
      "page-size": _vm.pageSize,
      "page-sizes": [10, 20, 30, 40]
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "size-change": _vm.handleSizeChange
    }
  })], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };